'use client';

import { ComponentPropsWithoutRef, ComponentType } from 'react';
import { Layout } from '@/shared/ui/layout';
import './my-account-modal.scss';

type Props = ComponentPropsWithoutRef<typeof Layout> & {
    icon: ComponentType<ComponentPropsWithoutRef<'svg'>>;
    label: string;
};
export const MyAccountModalMenuItem = ({ icon: Icon, label, ...props }: Props) => {
    return (
        <Layout element="button" type="button" {...props}>
            <Layout
                media={{
                    initial: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                    },
                }}
            >
                <Icon
                    style={{
                        width: '1.5rem',
                        height: '1.5rem',
                        flexShrink: 0,
                        color: 'var(--color-primary)',
                    }}
                />
                <span
                    style={{
                        fontSize: '1.25rem',
                        fontWeight: 600,
                        lineHeight: '1.625rem',
                    }}
                >
                    {label}
                </span>
            </Layout>
            <Icon
                name="chevron-right"
                style={{
                    width: '1rem',
                    height: '2rem',
                    flexShrink: 0,
                    color: 'var(--color-gray-500)',
                }}
            />
        </Layout>
    );
};
